<template lang="html">
  <div id="app">
     <el-container class="MailDeliveryDestCont">
     <el-header>
       <div class="header-area">
       </div>
     </el-header>

     <el-main>
       <div class="header-inner-area">
         <ul>
           <li>
             <img class="logo" src="../../assets/image/logo-new.png" alt="LOGO" />
           </li>
         </ul>
       </div>
     </el-main>
   </el-container>
       <el-divider class="header-divider"></el-divider>
     <el-container class="password_reset">

        <div class="main-div">
           <el-container class="main-div parentDiv">
            
             <div id="SID0022__Container" class="SID0022__bodyDiv">
                 
                 <div class="MailDeliveryDestinationList-form">
                   <div class="labelTitle">
                       <el-form ref="form" :rules="rules" :model="form" class="div-form" label-width="auto">
                         <el-form-item class="el-lbl-content" label="企業コード" prop="input1">
                             <el-input size="small" placeholder="" v-model="form.input1"></el-input>
                         </el-form-item>
                         <el-form-item class="el-lbl-content" label="ユーザーID" prop="input2">
                             <el-input size="small" placeholder="" v-model="form.input2"></el-input>
                         </el-form-item>
                         <el-row class="Button0022Align">
                             <el-button @click="onSubmit('form')" :disabled="Buttonpressed == 1" type="primary" plain>送信 </el-button>
                             <el-button class="button-0022" @click="goBack()" type="info" plain >戻る </el-button>
                         </el-row>
                       </el-form>
                   </div>
                 </div>
             </div>
           </el-container>
        </div>
     </el-container>
     <el-container class="footer-div">
       <el-footer class="footer0022 footer-element">
           <FooterComponent />
       </el-footer>
     </el-container>
  </div>
</template>
<script lang="js">
import { mapGetters } from "vuex";
import Vue from 'vue'
import FooterComponent from "../common/footerComponent.vue";
import json from "../../components/config.json";
import router from '../../router';
 export default  {
   name: 'SID0022',
   components: {
   FooterComponent,
 },
   props: [],
   mounted () {
     this.form.input1 = this.$route.params.credentials.contract_code;
     this.form.input2 = this.$route.params.credentials.user_id;
   },
   data () {
     var confirmLengthinput1 = (rule, value, callback) => {
   var passCheck= this.form.input1 ;
           if (passCheck.length > 12) {
             callback(new Error('Enter confirm length of password'));
           } 
           else {
             callback();
           }
   };
    var confirmLengthinput2 = (rule, value, callback) => {
   var passCheckLength= this.form.input2 ;
           if (passCheckLength.length > 256) {
             callback(new Error('Enter confirm 20 char of password'));
           } 
           else {
             callback();
           }
   };
  

    return {
      Buttonpressed: 0,
      form: {
        input1:'',
      input2:'',
      },
      rules: {
       input1: [
          { required: true,type:"string", message: '企業コードを入力してください。'},
          {  validator: confirmLengthinput1, message: '企業コードは12文字以下を入力してください。'},
          { pattern:/^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/,message:'企業コードは半角英数字を入力してください。'},
          /*** Change by BM for backlog Id: 1636 removed "/" from the pattern*/
          { pattern:/^[\u30ff\u3400-\u4dbf\uf900-\ufaff\uff66-\uff9fa-zA-Z0-9]+$/,message:'企業コードは記号を入力できません。'}
            ],
      input2: [
           { required: true,type:"string", message: 'ユーザーIDを入力してください。'},
           {  validator: confirmLengthinput2, message: 'ユーザーIDは256文字以下を入力してください。'},
           {  pattern:/^[/a-zA-Z0-9-!#$%^&*()_+|~=`{}[\]:";'<>?,. @]+$/, message: 'ユーザーIDは半角英数字を入力してください。'}
          ],
     }
     }
   },
   computed: {
   ...mapGetters("situation0022", [
     "getcheck",
     "getname",
     "getStatus",
     "getMsgDetail"
   ])
 },
   methods: {
     //create password reset link
   onSubmit(formName) {
     this.$LogButtonEvent("0022","Send");
     this.$LogMethodIN("0022","onSubmit");
     this.$refs[formName].validate((valid) => {
         if (valid) {
           var credential = {
                           contract_code: this.form.input1,
                           user_id:this.form.input2
           };
            this.Buttonpressed= 1;
           this.$store.dispatch('communication0022/resetPassword',credential).then(() => {
            
           var status = this.getStatus;
             if(status == 0){
                  
                   var time = new Date();
                    var settime = time.setMinutes( time.getMinutes() + 10 );
                    var newdate= new Date(settime)
                   Vue.prototype.$session.set('time', newdate);
                    this.$alert(json["0022_transmission_success_message"], json["0022_transmission_success_title"], {
                     confirmButtonText: 'OK',
                   });
                   this.$refs[formName].resetFields();
                 }else{
                   this.$alert(this.getMsgDetail, json["0022_transmission_failure_title"], {
                     confirmButtonText: 'OK',
                   }).then(() => {
                      this.Buttonpressed= 0;
                   })
                   this.$refs[formName].resetFields();
                 }
             
          }) 
         } else {
           return false;
         }
       });
       this.$LogMethodOut("0022","onSubmit");
   },
   goBack(){
     this.$LogButtonEvent("0022","Return");
     this.$LogMethodIN("0022","goBack");
     router.push({name:"0001"});
     this.$LogMethodOut("0022","goBack");
   }
   },
   gotoback(){
     router.push({name:"0001"});
   },
   created() {
    //For the screen Title
     document.title = "記事閲覧";
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
        this.$router.push('sp/0022');
    }
    else{
        this.$router.push('/0022');
    }

  }
   
   
}
</script>

<style scoped>
@import "0022.css";
</style>